import { Component, OnInit, OnChanges, Input, ElementRef } from '@angular/core';

@Component({
  selector: 'app-read-more',
  templateUrl: './read-more.component.html',
  styleUrls: ['./read-more.component.css']
})
export class ReadMoreComponent implements OnChanges {
  @Input() text: string;
  @Input() maxLength: number = 100;
  @Input() textAlign: string;
  currentText: string;
  trimText:string;

  public isCollapsed: boolean = true;

  constructor(private elementRef: ElementRef) {

  }

  toggleView() {
    this.isCollapsed = !this.isCollapsed;
    this.determineView();
  }

  determineView() {
    if (!this.text || this.text.length <= this.maxLength) {
        this.currentText = this.text;
        this.isCollapsed = false;
        return;
    }
    if (this.isCollapsed == true) {
        this.currentText = this.text.substring(0, this.maxLength) + "...";
        this.trimText = this.text.substring(this.maxLength + 1, this.text.length);
    } else if(this.isCollapsed == false)  {
        this.currentText = this.text;
    }
  }

  ngOnChanges() {
    this.determineView();       
  }
}
